import EmailIcon from "@mui/icons-material/Email";
import { getCMSDataField } from "app/utils/getCMSDataField";
import { SocialAuthConnectionType } from "app/utils/socialAuth";
import { CMSDataValueModel } from "app/state/api/action-reducers/sync";
import { ReactComponent as GoogleIcon } from "app/assets/vectors/HeaderSignInViewGoogle.svg";
import { ReactComponent as LinkedinIcon } from "app/assets/vectors/HeaderSignInViewLinkedin.svg";
import { ReactComponent as MicrosoftIcon } from "app/assets/vectors/HeaderSignInViewMicrosoft.svg";

export const getSignInMethods = (cmsData: CMSDataValueModel | null) => {
  const SignInMethods: {
    title: string;
    icon: React.ReactNode;
    type: SocialAuthConnectionType | "email-otp";
  }[] = [
    {
      title: getCMSDataField(cmsData, "general.signInWithGoogleText", "Google"),
      icon: <GoogleIcon />,
      type: "google-oauth2",
    },
    {
      title: getCMSDataField(
        cmsData,
        "general.signInWithLinkedinText",
        "LinkedIn"
      ),
      icon: <LinkedinIcon />,
      type: "linkedin",
    },
    {
      title: getCMSDataField(
        cmsData,
        "general.signInWithMicrosoftText",
        "Microsoft"
      ),
      icon: <MicrosoftIcon />,
      type: "windowslive",
    },
    {
      title: getCMSDataField(
        cmsData,
        "general.signInWithEmailOTPText",
        "Email OTP"
      ),
      icon: <EmailIcon />,
      type: "email-otp",
    },
  ];
  return SignInMethods;
};
